import { useEffect } from 'react';

import { useAppDispatch } from '@/store';
import { startLoading, stopLoading } from '@/store/app.slice';

const SuspenseFallback: React.FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(startLoading());
    return () => {
      dispatch(stopLoading());
    };
  }, []);

  return null;
};

export default SuspenseFallback;
